import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputPhoneField from '../FormInputPhoneField/FormInputPhoneField.vue'
import FormInputEmailField from '../FormInputEmailField/FormInputEmailField.vue'
import nameValidator from "foundation/js/inputValidators/nameValidator"
import phoneValidator from "foundation/js/inputValidators/phoneValidator"
import emailValidator from "foundation/js/inputValidators/emailValidator"
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'

export default {
    name: "CreateStafetProfile",
    components: {
        FormInputTextField,
        FormInputPhoneField,
        FormInputEmailField,
    },
    props: {
        userProfileId: {
            type: String,
            default: true
        },
        email: {
            type: String,
            required: true
        },
        firstName: {
            type: String,
            required: true
        },
        lastName: {
            type: String,
            required: true
        },
        phone: {
            type: String,
            required: true
        },
        informationRichText: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const store = useStore()

        const firstNameInput = ref(props.firstName)
        const lastNameInput = ref(props.lastName)
        const phoneInput = ref(props.phone)
        const emailInput = ref(props.email)
        const informationRichTextWrapper = ref(null)
        const displayError = ref(false)
        const isSubmitting = computed(() => store.state.stafet.isSubmitting)

        const isReadOnly = ref({
            firstName: !!props.firstName,
            lastName: !!props.lastName,
            phone: !!props.phone,
        })

        const isFirstNameValid = computed(() => isReadOnly.value.firstName || (firstNameInput.value !== '' && nameValidator(firstNameInput.value)))
        const isLastNameValid = computed(() => isReadOnly.value.lastName || (lastNameInput.value !== '' && nameValidator(lastNameInput.value)))
        const isPhoneValid = computed(() => isReadOnly.value.phone || (phoneInput.value !== '' && phoneValidator(phoneInput.value)))
        const isEmailValid = computed(() => isReadOnly.value.email || (emailInput.value !== '' && emailValidator(emailInput.value)))

        const labels = computed(() => {
            return store.state.labels.collections['CreateStafetProfile']
        })


        const showFirstNameErrorMessage = computed(() => {
            const hasError = !isFirstNameValid.value && displayError.value
            return hasError
        })
        
        const showLastNameErrorMessage = computed(() => {
            const hasError = !isLastNameValid.value && displayError.value
            return hasError
        })

        const showPhoneErrorMessage = computed(() => {
            const hasError = !isPhoneValid.value && displayError.value
            return hasError
        })

        const showEmailErrorMessage = computed(() => {
            const hasError = !isEmailValid.value && displayError.value
            return hasError
        })

        const submitCreateProfile = () => {
            if (isFirstNameValid.value && isLastNameValid.value && isPhoneValid.value && isEmailValid.value) {
                displayError.value = false
                store.dispatch('stafet/submitCreateStafetProfile', {
                    userProfileId: props.userProfileId,
                    email: props.email,
                    firstName: firstNameInput.value,
                    lastName: lastNameInput.value,
                    phoneNumber: phoneInput.value,
                })
            } else {
                displayError.value = true
                scrollToFirstError()
            }
        }

        const decodeHtml = (htmlRaw) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = htmlRaw
            return txt.value
        }

        onMounted(() => {
            const informationRichTextHtml = decodeHtml(props.informationRichText)
            informationRichTextWrapper.value.innerHTML = informationRichTextHtml
        })

        return {
            labels,
            submitCreateProfile,
            firstNameInput,
            lastNameInput,
            phoneInput,
            isReadOnly,
            informationRichTextWrapper,
            isSubmitting,
            displayError,
            isFirstNameValid,
            isLastNameValid,
            isPhoneValid,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showPhoneErrorMessage,
            showEmailErrorMessage
        }
    }
}